/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ContentStackSegmentation } from '../../interface/content-types';
import { isSegmentation } from './isSegmentation';

export type Segmentable = {
  segmentation: NonNullable<ContentStackSegmentation>;
};

export const isSegmentable = (item: unknown): item is Segmentable => {
  if (!item) {
    return false;
  }

  return Boolean(
    typeof item === 'object' &&
    'segmentation' in item &&
    item.segmentation &&
    isSegmentation(item.segmentation),
  );
};
